import { render, staticRenderFns } from "./DigitalVotingBanner.vue?vue&type=template&id=9fdf835c&scoped=true"
import script from "./DigitalVotingBanner.vue?vue&type=script&lang=js"
export * from "./DigitalVotingBanner.vue?vue&type=script&lang=js"
import style0 from "./DigitalVotingBanner.vue?vue&type=style&index=0&id=9fdf835c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fdf835c",
  null
  
)

export default component.exports